import { render, staticRenderFns } from "./InceptionAnnotationAssessmentIndex.vue?vue&type=template&id=4ddab8aa&scoped=true"
import script from "./InceptionAnnotationAssessmentIndex.vue?vue&type=script&lang=ts"
export * from "./InceptionAnnotationAssessmentIndex.vue?vue&type=script&lang=ts"
import style0 from "./InceptionAnnotationAssessmentIndex.vue?vue&type=style&index=0&id=4ddab8aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddab8aa",
  null
  
)

export default component.exports